export const getExpense = (
  payload,
  url,
  hasRole,
  key,
  callBack,
  fromRefresh,
  filterQuery,
) => ({
  type: 'SEARCH',
  // loader: true,
  payload,
  url,
  hasRole,
  key,
  callBack,
  fromRefresh,
  filterQuery,
});
export const setExpenseList = (data, key, filterQuery) => ({
  type: 'SET_EXPENSE',
  data,
  key,
  filterQuery,
});
export const getSearchFields = payload => ({
  type: 'SEARCHFIELDS',
  payload,
});
export const setSearchFields = data => ({
  type: 'SET_SEARCH_FIELDS',
  data,
});

export const clearexpense = data => ({
  type: 'CLEAREXPENSE',
  data,
});

export const setDispute = (payload, callBack) => ({
  type: 'SET_DISPUTE',
  payload,
  callBack,
  loader: true,
});

export const getDisputeReason = payload => ({
  type: 'GET_DISPUTE_REASON',
  payload,
});

export const setExpenseDisputeReason = data => ({
  type: 'SET_DISPUTE_REASON',
  data,
});

export const showSnackbar = data => ({
  type: 'SHOW_SNACK_BAR',
  data,
});

export const getExpenseDetailsUser = payload => ({
  type: 'GET_TRANSACTION',
  payload,
});

export const setExpenseDetails = data => ({
  type: 'SET_SINGLE_TXN_DATA',
  data,
});

export const updateDisputeInTxn = (payloadDispute, callBack) => ({
  type: 'TXN_DISPUTE_WITHDRAW',
  payloadDispute,
  callBack,
});

export const getGlobalSearchData = (payload, url) => ({
  type: 'GLOBAL_SEARCH',
  payload,
  url,
});

export const deleteInvoiceVendor = (payload, url, callBack) => {
  return {
    type: 'DELETE_INV_VEN',
    payload,
    url,
    callBack,
  };
};

export const getAllSavedColumn = payload => ({
  type: 'GET_COLUMN',
  payload,
});

export const setAllSavedColumn = column => ({
  type: 'SET_COLUMN',
  column,
});

export const postAllSavedColumn = payload => ({
  type: 'POST_COLUMN',
  payload,
});

export const clearExpenseFilterQuery = () => ({
  type: 'CLEAR_EXPENSE_FILTER_QUERY',
});
